//region block: pre-declaration
//endregion
function threadContextElements(context) {
  return 0;
}
//region block: exports
export {
  threadContextElements as threadContextElements12yd4mfmaodla,
};
//endregion

//# sourceMappingURL=ThreadContext.mjs.map
